export default function geocode(location, callback) {
    performAjax({q: location}, callback)
}

export function geocodeFullAddress(address, town, postcode, callback) {
    performAjax({
        street: address,
        city: town,
        postalcode: postcode
    }, function (data) {
        if (data) {
            callback(data)
        } else {
            performAjax({
                street: address,
                city: town
            }, callback)
        }
    })
}

function performAjax(data, callback) {
    $.ajax({
        url: "https://nominatim.openstreetmap.org/search",
        data: Object.assign({
            format: "json",
            countrycodes: "gb,ie",
            limit: 1
        }, data)
    }).done(function (data) {
        if (data.length > 0) {
            callback(data[0])
        } else {
            callback(false)
        }
    });
}